import { Typography } from '@material-tailwind/react';
import { FreeTrialContextItem } from '../../constants/types/free-trial/type';
import { removeSurname, vocativeParticle } from '../../api/utils/util-func';

interface FreeTrialHeroProps {
  freeTrialContext: FreeTrialContextItem;
}

/* Hero */
const FreeTrialHero = ({ freeTrialContext }: FreeTrialHeroProps) => {
  return (
    <section className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
      <div className="mb-2 md:mb-0">
        {/* <div> */}
        <div className="mb-3 inline-flex rounded-full bg-[#F1EDFF] px-3 py-1.5">
          <Typography className="text-[11px] font-bold text-[#6737F4] md:text-[12px]">
            오늘의 미션 · 잉스바 In the beginning
          </Typography>
        </div>

        <Typography className="text-[30px] font-black leading-[1.2] text-[#242030] md:text-[38px]">
          그림으로 말씀 암송하고,
          <br />
          <span className="text-[#6737F4]">AI 스피킹 인증</span>
          까지 완성해요!
        </Typography>

        <Typography className="mt-4 max-w-[620px] text-[14px] leading-6 text-gray-700 md:text-[15px] md:leading-7">
          엄마와 같이 수업하고, 아이가 혼자 복습하고 AI 인증제에 도전해요.
          <br />
          3단계를 모두 마치면 나만의 인증 리포트가 생겨요!
        </Typography>
      </div>

      <div className="relative flex justify-center md:w-[210px]">
        <div className="relative inline-block">
          <img
            src="/images/free-trial/bready.png"
            alt="bready"
            className="animate-bready-float h-[130px] w-[130px] object-contain md:h-[150px] md:w-[150px]"
          />

          <div className="absolute left-1/2 top-0 z-10 -translate-x-1/2 -translate-y-[95%] whitespace-nowrap rounded-lg rounded-br-none bg-[#211B2D] px-3 py-2 text-[11px] font-bold text-white shadow-md md:text-[12px]">
            {vocativeParticle(removeSurname(freeTrialContext.childName))}, 함께
            해보자!
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeTrialHero;
